<template>
  <step-wrapper space-between>
    <step-header :text="text" step="1" step-count="4" strong/>
    <content-wrapper>
      <text-input
        class="name-input"
        v-model="place.name"
        placeholder="Nazwa miejsca"
        :required="true"
      />
      <text-input
        :value="place.title"
        :button="buttonText"
        disabled
        placeholder="Adres"
        @click="activateMap"
      />
    </content-wrapper>
    <content-wrapper type="small">
      <button-component
        :disabled="isButtonDisabled"
        fixed-width
        @click="goToNextStep"
      >
        Dalej
      </button-component>
    </content-wrapper>
  </step-wrapper>
</template>

<script>
import {mapState} from 'vuex'
import StepWrapper from '@/components/StepWrapper'
import ContentWrapper from '@/components/ContentWrapper'
import StepHeader from '@/components/StepHeader'
import TextInput from '@/components/TextInput'
import ButtonComponent from '@/components/Button'

export default {
  components: {
    StepWrapper,
    StepHeader,
    ContentWrapper,
    TextInput,
    ButtonComponent
  },
  data () {
    return {
      text: `
        Dodaj nazwę miejsca w Warszawie<br>oraz dodaj je do mapy
      `
    }
  },
  computed: {
    ...mapState({
      place: state => state.add.place
    }),
    buttonText () {
      return this.place.title ? 'Zmień' : 'Wybierz'
    },
    isButtonDisabled () {
      return !this.place.name || !this.place.title
    }
  },
  methods: {
    activateMap () {
      this.$router.push({ name: 'add-pick' })
    },
    goToNextStep () {
      this.$router.push({ name: 'add-step-2' })
    }
  }
}
</script>

<style lang="scss" scoped>
  .name-input {
    margin-bottom: 37px;

    @include media-up(xl) {
      margin-bottom: 60px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/containers/AddPlace/AddFirstStep.vue